import React, {useEffect, useMemo, useState} from 'react'
import Helmet from 'react-helmet'
import Cookies from "js-cookie";
import { useParams } from 'react-router-dom'
import axios from 'axios'
import {useAtomValue, useUpdateAtom} from 'jotai/utils'
import {useDispatch, useSelector} from 'react-redux'
import {FormattedMessage} from 'react-intl'
import {useSearchParams, useNavigate} from 'react-router-dom'
//import CookieConsent from 'react-cookie-consent'
import Grid from '@mui/material/Grid'
//import {withStyles} from '@mui/styles'
import {sidebarWitdh} from 'components/utils'
import {API_URL} from 'api/config'
import {useQuery} from '@tanstack/react-query'
import ErrorBoundary from 'components/ErrorBoundary'
import PlaybackBar from 'components/PlaybackBar'
import PlaybackBarPoi from 'components/PlaybackBarPoi'
import TourControls from 'components/TourControls'
import ConnectionInfo from 'components/ConnectionInfo'
import SitePlan from 'components/SitePlan'
import {
  setNavigation,
} from 'components/Navigation/duck'
import {
  iframeDocAtom,
  sidebarAtom,
  tourMachineAtom,
  isTourStartedAtom,
  individuelleTourUrlAtom ,
} from 'components/jotai'
import useNavigateToPlaylistItem from 'components/Hooks/useNavigateToPlaylistItem'
import { getIsLoggedIn, invalidateUser} from 'components/user/duck'
import { getNavigationContext } from 'components/xstate/NavigationMachine'
import IconAbb from 'assets/img/faviconAbb.ico'
import IconBje from 'assets/img/faviconBje.ico'
import IconStriebel from 'assets/img/faviconStriebel.ico'

export default function TourView() {
  const brand = 'bje'
  const drawerOpen = useAtomValue(sidebarAtom)
  const dispatch = useDispatch()
  const setIFrameDoc = useUpdateAtom(iframeDocAtom)
  const { id } = useParams()
  const [playlistItems, setPlaylistItems] = useState([])
  const individuelleTourUrl = useAtomValue(individuelleTourUrlAtom)
  const {navigateToPlaylistItem} = useNavigateToPlaylistItem()
  const naviContext = useSelector(getNavigationContext)
 
  const playlistItemsProps = useQuery({
    queryKey: ['playlistItems'],
    queryFn: () =>
      axios({
        method: 'get',
        url: `${API_URL}/api/playlistItems`,
      }).then((res) => {
        return res?.data || []
      }),
      select: (data) => data.reduce((acc, item) => {
        acc[item.id] = item
        return acc
      }, {})
  })
  const mappedPlaylistItems = useMemo(() => {
    return playlistItemsProps.data || {}
  }, [playlistItemsProps.data])

  const tourService = useAtomValue(tourMachineAtom)
  const setTourIsStarted = useUpdateAtom(isTourStartedAtom)
  const [searchParams] = useSearchParams()
  

  useEffect(() => {
    if (Object.keys(mappedPlaylistItems).length > 0 && naviContext?.stateKey) {
      navigateToPlaylistItem(id, mappedPlaylistItems)
    }
   
  }, [id, mappedPlaylistItems, naviContext])

  useEffect(() => {
    const item = mappedPlaylistItems[id]
    if (item) {
      dispatch({type: 'INDIVIDUELL'})
      dispatch(
        setNavigation({
          id: id,
          pages: [{
            label: item.id,
            subtitle: item.name,
            tourId: item.tourId,
            thumbnailUrl: item.thumbnailUrl,
          }]
        })
      )
    }
  }, [id, mappedPlaylistItems])

  const title = useMemo(() => {
    return 'Individuelle Tour'
  }, [])

  useEffect(() => {
    const url2 = window.location.origin

    let myDynamicManifest = {
      short_name: 'Factory Tour',
      name: 'Factory Tour',
      display: 'standalone',
      orientation: 'any',
      background_color: '#ffffff',
      theme_color: '#FFF',
      scope: `${url2}/`,
      start_url: `${url2}/`,
      icons: [
        {
          src: `${url2}/logoBje192.jpg`,
          type: 'image/png',
          sizes: '192x192',
        },
        {
          src: `${url2}/logoBje512.jpg`,
          type: 'image/png',
          sizes: '512x512',
        },
      ],
    }

    let link = document.getElementById('manifest')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'manifest'
      link.id = 'manifest'
    }
    const stringManifest = JSON.stringify(myDynamicManifest)
    link.setAttribute(
      'href',
      'data:application/json;charset=utf-8,' +
        encodeURIComponent(stringManifest),
    )
    document.head.appendChild(link)

    window.onload = function() {
      let frameElement = document.getElementById('tourFrame')
      if (frameElement) {
        let doc = frameElement.contentDocument

        if (doc) {
          setIFrameDoc(doc)
          doc
            .getElementById('preloadContainer')
            ?.setAttribute('style', 'opacity:1;cursor:pointer;')
        }
      }
    }

    return () => {
      setTourIsStarted(false)
    }
  }, [brand, setIFrameDoc, setTourIsStarted])

  const yaw = searchParams.get('yaw')
  const pitch = searchParams.get('pitch')

  const params = useMemo(() => {
    let str = ``

    if (yaw) {
      if (str.length > 0) {
        str = `${str}&yaw=${yaw}`
      } else {
        str = `?yaw=${yaw}`
      }
    }

    if (pitch) {
      if (str.length > 0) {
        str = `${str}&pitch=${pitch}`
      } else {
        str = `?pitch=${pitch}`
      }
    }

    return str
  }, [yaw, pitch])

  const renderEl = useMemo(() => !!tourService, [tourService])

  return (
    <ErrorBoundary>
      <Helmet>
        <title>{title}</title>
        <link
          id="favicon"
          rel="icon"
          href={IconBje}
        />
        <link
          rel="apple-touch-icon"
          href={`${window.location.origin}/logoBje192.jpg`}
        />
      </Helmet>
      <Grid container sx={{width: '100vw', height: '100vh'}}>
          {(!id || !mappedPlaylistItems[id]) &&
            <Grid item xs={12} sx={{padding: 4, marginLeft: drawerOpen ? `${sidebarWitdh}px` : 0}}>
              <FormattedMessage
                id="station.not.found"
                defaultMessage="Die Station mit dieser ID konnte nicht gefunden werden."
              />
            </Grid>
          }
        {id && mappedPlaylistItems[id] &&
          <Grid item xs={12}>
            <div style={{position: 'relative', height: '100%'}}>
              <iframe
                id="tourFrame"
                title={title}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 1000,
                }}
                src={`${individuelleTourUrl}${params}`}
                name="tourFrame"
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                allow="fullscreen; accelerometer; gyroscope; magnetometer; vr; xr; xr-spatial-tracking; autoplay; camera; microphone"
                sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
              />
            </div>
          </Grid>
        }
      </Grid>
      {renderEl && <PlaybackBar />}
      {renderEl && <PlaybackBarPoi />}
      {renderEl && <TourControls />}
      {renderEl && <SitePlan tour={'individuell'} />}
      <ConnectionInfo />
    </ErrorBoundary>
  )
}
